<div class="container-fluid padding-top padding-bottom">
  <md-card *ngIf="clientData;"
           class="margin-bottom">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-accent"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>{{ clientData?.name}}</h1>
      </div>
      <div class="col-md-12">
        <h2>Component Structure Settings</h2>
        <p>In any of the boxes labeled Background you can do a hex (#ff43ff), rgba(255, 255, 255, 0) or
          url(https://myimage.com).</p>
        <button id="toggleSettings"
                class="btn btn-accent"
                (click)="toggleOldSettings()">Toggle All Settings</button>
      </div>
    </div>


    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Nav Bar</h1>
        <hr>
        <h5>Styles&nbsp;&nbsp;<a href="https://material.io/icons/"
             target="_blank">Material Icons</a></h5>

      </div>
      <component-structure class="col-sm-6"
                           [name]="'Information Bar (with Phone and Portal Login)'"
                           [model]="'infoBarStyle'"
                           [dataName]="'infoBarStyleData'"
                           [clientData]="clientData"
                           [options]="infoBarStyleOptions"></component-structure>

      <component-structure class="col-sm-6"
                           [name]="'Location Bar (to change Selected Location)'"
                           [model]="'locationBarStyle'"
                           [dataName]="'locationBarStyleData'"
                           [clientData]="clientData"
                           [options]="locationBarStyleOptions"></component-structure>
    </div>

    <!--     <div class="row margin-top">
      <div class="col-md-12">
        <h5>Locations</h5>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Information Bar (with Phone and Portal Login)'"
                           [model]="'infoNavLocation'"
                           [clientData]="clientData"
                           [options]="navBarLocationOptions"></component-structure>

      <component-structure class="col-sm-6"
                           [name]="'Location Bar (to change Selected Location)'"
                           [model]="'locationNavLocation'"
                           [clientData]="clientData"
                           [options]="navBarLocationOptions"></component-structure>
    </div> -->
    <!--<h3 class="first">Information Bar (with Phone and Portal Login)</h3>-->
    <!--<p-dropdown [options]="navBarLocationOptions" (onChange)="updateClient()" [(ngModel)]="clientData.infoNavLocation" placeholder="Select"></p-dropdown>-->
    <!--<h3 class="first">Location Bar (to change Selected Location)</h3>-->
    <!--<p-dropdown [options]="navBarLocationOptions" (onChange)="updateClient()" [(ngModel)]="clientData.locationNavLocation" placeholder="Select"></p-dropdown>-->
    <div class="row margin-top">
      <component-structure class="col-sm-6"
                           [name]="'Main Navbar'"
                           [model]="'mainNavBar'"
                           [dataName]="'mainNavBarStyleData'"
                           [clientData]="clientData"
                           [options]="mainNavBarOptions"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Home Page</h1>
        <hr>
      </div>
      <div class="col-sm-6">
        <h5>Hero</h5>
        <p>Header Type</p>
        <p-dropdown [options]="headerType"
                    (onChange)="savePageSettings()"
                    [(ngModel)]="pageSettings?.home.headerType"></p-dropdown>
        <div *ngIf="pageSettings?.home.headerType == 'simple-video' || pageSettings?.home.headerType == 'video' || pageSettings?.home.headerType == 'big-title'"
             class="row">
          <div *ngIf="pageSettings?.home.headerType == 'simple-video'"
               class="col-xs-12">
            <p-dropdown [options]="simpleHeroTabBoxOptions"
                        (onChange)="saveComponentSettings()"
                        [(ngModel)]="componentSettings.simpleHeroTabBox"
                        placeholder="Tab Box Version"></p-dropdown>
          </div>
          <div class="col-md-3 padding-top">
            <label for="videoHeaderUrl">Video Header URL</label>
          </div>
          <div class="col-md-9 padding-top padding-bottom">
            <input (change)="saveComponentSettings()"
                   class="full-width"
                   pInputText
                   id="videoHeaderUrl"
                   [(ngModel)]="componentSettings.videoHeaderUrl" />
          </div>
        </div>

        <div *ngIf="pageSettings?.home.headerType == 'slider' || pageSettings?.home.headerType == 'video'"
             class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label for="subtractFromFullHeight">Subtract from Full Height (number only)
              </label>
              <input type="number"
                     class="form-control"
                     id="subtractFromFullHeight"
                     [(ngModel)]="componentSettings.subtractFromFullHeight"
                     (change)="saveComponentSettings()">
            </div>
          </div>
        </div>

        <div class="row"
             *ngIf="pageSettings?.home.headerType !== 'insights'">
          <div class="col-xs-12">
            <md-slide-toggle id="hideVideoAndImagesOnMobile"
                             (change)="saveMdToggle($event, 'hideVideoAndImagesOnMobile')"
                             [(ngModel)]="componentSettings.hideVideoAndImagesOnMobile"> Hide Slideshow/Video on mobile
              (tabbox)</md-slide-toggle>
          </div>
        </div>
        <div *ngIf="pageSettings?.home.headerType == 'slider' || pageSettings?.home.headerType == 'simple' || pageSettings?.home.headerType == 'big-buttons' || pageSettings?.home.headerType == 'insights'"
             class="row">
          <div *ngIf="pageSettings?.home.headerType == 'simple'"
               class="col-xs-12">
            <p-dropdown [options]="simpleHeroTabBoxOptions"
                        (onChange)="saveComponentSettings()"
                        [(ngModel)]="componentSettings.simpleHeroTabBox"
                        placeholder="Tab Box Version"></p-dropdown>
          </div>
          <div *ngIf="pageSettings?.home.headerType == 'big-buttons' || pageSettings?.home.headerType == 'insights'"
               class="col-xs-12 padding-top">
            <md-slide-toggle id="useVideoInstead"
                             (change)="saveMdToggle($event, 'useVideoInstead')"
                             [(ngModel)]="componentSettings.useVideoInstead"> Use Video Instead</md-slide-toggle>
          </div>
          <div *ngIf="pageSettings?.home.headerType == 'big-buttons' || pageSettings?.home.headerType == 'insights'"
               class="col-xs-12">
            <md-slide-toggle id="leftButtonScrollsToLocations"
                             (change)="saveMdToggle($event, 'leftButtonScrollsToLocations')"
                             [(ngModel)]="componentSettings.leftButtonScrollsToLocations"> Left Button Scrolls to
              Locations</md-slide-toggle>
          </div>
          <div *ngIf="pageSettings?.home.headerType == 'big-buttons' || pageSettings?.home.headerType == 'insights'"
               class="col-xs-12">
            <md-slide-toggle id="rightButtonScrollsToLocations"
                             (change)="saveMdToggle($event, 'rightButtonScrollsToLocations')"
                             [(ngModel)]="componentSettings.rightButtonScrollsToLocations"> Right Button Scrolls to
              Locations</md-slide-toggle>
          </div>
          <div *ngIf="pageSettings?.home.headerType == 'big-buttons'"
               class="col-xs-12">
            <md-slide-toggle id="bigOlButtons"
                             (change)="saveMdToggle($event, 'bigOlButtons')"
                             [(ngModel)]="componentSettings.bigOlButtons"> Big Ol Buttons for Mobile Storage
            </md-slide-toggle>
          </div>
          <div class="col-xs-12"
               [class.padding-top]="pageSettings?.home.headerType != 'big-buttons' && 'insights'">
            <md-slide-toggle id="showSliderArrows"
                             (change)="saveMdToggle($event, 'showSliderArrows')"
                             [(ngModel)]="componentSettings.showSliderArrows"> Show Arrows</md-slide-toggle>
          </div>
          <div class="col-xs-12">
            <md-slide-toggle id="sliderAutoPlay"
                             (change)="saveMdToggle($event, 'sliderAutoPlay')"
                             [(ngModel)]="componentSettings.sliderAutoPlay"> Autoplay Slider</md-slide-toggle>

          </div>
          <div class="col-xs-12">
            <md-slide-toggle id="sliderLocationImages"
                             (change)="saveMdToggle($event, 'sliderLocationImages')"
                             [(ngModel)]="componentSettings.sliderLocationImages"> Use different images for each
              location instead</md-slide-toggle>

          </div>
          <ng-container *ngIf="pageSettings?.home.headerType !== 'insights'">
            <div *ngIf="componentSettings.bigOlButtons"
                 class="col-xs-12">
              <label>Big Ol' Buttons Top Text</label>
              <input (change)="saveComponentSettings()"
                     class="full-width"
                     pInputText
                     id="bigOlButtonsTopText"
                     placeholder="Get Your Free Quote"
                     [(ngModel)]="componentSettings.bigOlButtonsTopText" />

              <label>Big Ol' Buttons Bottom Text</label>
              <input (change)="saveComponentSettings()"
                     class="full-width"
                     pInputText
                     id="bigOlButtonsBottomText"
                     placeholder="Ready to start your next project? Book online today!"
                     [(ngModel)]="componentSettings.bigOlButtonsBottomText" />
            </div>
          </ng-container>

          <div
               *ngIf="(pageSettings?.home.headerType != 'big-buttons' && pageSettings?.home.headerType != 'insights') || ((pageSettings?.home.headerType == 'big-buttons' && !componentSettings.useVideoInstead) || (pageSettings?.home.headerType == 'insights' && !componentSettings.useVideoInstead))">
            <div class="col-xs-12 mt-5">
              <label>Slider Header URLs (location-specific in location settings)</label>
              <app-slideshow (onSave)="saveComponentSettings($event)"
                             [slides]="componentSettings.sliderUrls"
                             [showSliderArrows]="componentSettings.showSliderArrows"
                             [sliderAutoPlay]="componentSettings.sliderAutoPlay"></app-slideshow>
            </div>
          </div>
          <div
               *ngIf="(pageSettings?.home.headerType == 'big-buttons' || pageSettings?.home.headerType == 'insights')&& componentSettings?.useVideoInstead">
            <div class="col-md-3 padding-top">
              <label for="videoHeaderUrl">Video Header URL</label>
            </div>
            <div class="col-md-9 padding-top">
              <input (change)="saveComponentSettings()"
                     class="full-width"
                     pInputText
                     id="videoHeaderUrl"
                     [(ngModel)]="componentSettings.videoHeaderUrl" />
            </div>
          </div>
        </div>
        <div class="simple-title-wrapper padding-top"
             *ngIf="pageSettings?.home.headerType == 'simple' || pageSettings?.home.headerType == 'simple-video'">
          <div class="col-xs-8">
            <div class="form-group">
              <label for="Title">Title</label>
              <input type="email"
                     class="form-control"
                     id="Title"
                     [(ngModel)]="componentSettings.simpleSliderBanner.title"
                     (change)="saveComponentSettings()"
                     placeholder="Find your unit now">
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="TitleFontSize">Title Font Size</label>
              <input type="email"
                     class="form-control"
                     id="TitleFontSize"
                     [(ngModel)]="componentSettings.simpleSliderBanner.titleFontSize"
                     (change)="saveComponentSettings()"
                     placeholder="39px">

            </div>
          </div>

          <div class="col-xs-4">
            <div class="form-group">
              <label for="Padding">Padding
              </label>
              <input type="email"
                     class="form-control"
                     id="Padding"
                     [(ngModel)]="componentSettings.simpleSliderBanner.padding"
                     (change)="saveComponentSettings()"
                     placeholder="0">
            </div>
          </div>

          <div class="col-xs-4">
            <div class="form-group">
              <label for="button-margin">Button Margin</label>
              <input type="email"
                     class="form-control"
                     id="button-margin"
                     [(ngModel)]="componentSettings.simpleSliderBanner.buttonMargin"
                     (change)="saveComponentSettings()"
                     placeholder="15px auto auto auto">
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="title-margin">Title Margin</label>
              <input type="email"
                     class="form-control"
                     id="title-margin"
                     [(ngModel)]="componentSettings.simpleSliderBanner.titleMargin"
                     (change)="saveComponentSettings()"
                     placeholder="auto auto 0 auto">
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="Background">Background
                <div class="color-block"
                     [ngStyle]="{'background': componentSettings.simpleSliderBanner.background}"></div>
              </label>
              <input type="email"
                     class="form-control"
                     id="Background"
                     [(ngModel)]="componentSettings.simpleSliderBanner.background"
                     (change)="saveComponentSettings()"
                     placeholder="rgba(58, 78, 162, .3)">
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="color">Color
                <div class="color-block"
                     [ngStyle]="{'background': componentSettings.simpleSliderBanner.color}"></div>
              </label>
              <input type="email"
                     class="form-control"
                     id="color"
                     [(ngModel)]="componentSettings.simpleSliderBanner.color"
                     (change)="saveComponentSettings()"
                     placeholder="#fff">
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label>Button Text
              </label>
              <input class="form-control"
                     [(ngModel)]="componentSettings.simpleSliderBanner.buttonText"
                     (change)="saveComponentSettings()"
                     placeholder="View Locations">
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="sliderFilter">Slider Filter (overlay)
                <div class="color-block"
                     [ngStyle]="{'background': componentSettings.simpleSliderBanner.sliderFilter}"></div>
              </label>
              <input type="email"
                     class="form-control"
                     id="sliderFilter"
                     [(ngModel)]="componentSettings.simpleSliderBanner.sliderFilter"
                     (change)="saveComponentSettings()"
                     placeholder="rgba(0, 0, 0, 0.33)">
            </div>
          </div>
        </div>

        <div class="simple-title-wrapper padding-top"
             *ngIf="pageSettings?.home.headerType == 'big-buttons' || pageSettings?.home.headerType == 'insights'">
          <div class="col-xs-8">
            <div class="form-group">
              <label for="Title">Title</label>
              <input type="email"
                     class="form-control"
                     id="Title"
                     [(ngModel)]="componentSettings.simpleSliderBanner.title"
                     (change)="saveComponentSettings()"
                     placeholder="Find your unit now">
            </div>
          </div>
          <div class="col-xs-4"
               *ngIf="pageSettings?.home.headerType !== 'insights'">
            <div class="form-group">
              <label for="TitleFontSize">Title Font Size</label>
              <input type="email"
                     class="form-control"
                     id="TitleFontSize"
                     [(ngModel)]="componentSettings.simpleSliderBanner.titleFontSize"
                     (change)="saveComponentSettings()"
                     placeholder="39px">

            </div>
          </div>

          <div class="col-xs-8">
            <div class="form-group">
              <label for="Subtitle">Subtitle</label>
              <input class="form-control"
                     id="Subtitle"
                     [(ngModel)]="componentSettings.simpleSliderBanner.subtitle"
                     (change)="saveComponentSettings()"
                     placeholder="Find your unit now">
            </div>
          </div>
          <ng-container *ngIf="pageSettings?.home.headerType !== 'insights'">
            <div class="col-xs-4">
              <div class="form-group">
                <label for="SubtitleFontSize">Subtitle Font Size</label>
                <input type="email"
                       class="form-control"
                       id="TitleFontSize"
                       [(ngModel)]="componentSettings.simpleSliderBanner.subtitleFontSize"
                       (change)="saveComponentSettings()"
                       placeholder="25px">

              </div>
            </div>

            <div class="col-xs-4">
              <div class="form-group">
                <label for="Padding">Padding
                </label>
                <input type="email"
                       class="form-control"
                       id="Padding"
                       [(ngModel)]="componentSettings.simpleSliderBanner.padding"
                       (change)="saveComponentSettings()"
                       placeholder="0">
              </div>
            </div>

            <div class="col-xs-4">
              <div class="form-group">
                <label for="Subtitle-Padding">Subtitle Padding
                </label>
                <input class="form-control"
                       id="PaddSubtitle-Paddinging"
                       [(ngModel)]="componentSettings.simpleSliderBanner.subtitlePadding"
                       (change)="saveComponentSettings()"
                       placeholder="0">
              </div>
            </div>

            <div class="col-xs-4">
              <div class="form-group">
                <label for="button-margin">Button Margin</label>
                <input type="email"
                       class="form-control"
                       id="button-margin"
                       [(ngModel)]="componentSettings.simpleSliderBanner.buttonMargin"
                       (change)="saveComponentSettings()"
                       placeholder="15px auto auto auto">
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label for="title-margin">Title Margin</label>
                <input type="email"
                       class="form-control"
                       id="title-margin"
                       [(ngModel)]="componentSettings.simpleSliderBanner.titleMargin"
                       (change)="saveComponentSettings()"
                       placeholder="auto auto 0 auto">
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label for="Background">Title Background
                  <div class="color-block"
                       [ngStyle]="{'background': componentSettings.simpleSliderBanner.background}"></div>
                </label>
                <input type="email"
                       class="form-control"
                       id="Background"
                       [(ngModel)]="componentSettings.simpleSliderBanner.background"
                       (change)="saveComponentSettings()">
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label for="color">Title Color
                  <div class="color-block"
                       [ngStyle]="{'background': componentSettings.simpleSliderBanner.color}"></div>
                </label>
                <input type="email"
                       class="form-control"
                       id="color"
                       [(ngModel)]="componentSettings.simpleSliderBanner.color"
                       (change)="saveComponentSettings()"
                       placeholder="#fff">
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label for="subtitle-margin">Subtitle Margin</label>
                <input class="form-control"
                       id="subtitle-margin"
                       [(ngModel)]="componentSettings.simpleSliderBanner.subtitleMargin"
                       (change)="saveComponentSettings()"
                       placeholder="15px auto">
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label for="Background">Subtitle Background
                  <div class="color-block"
                       [ngStyle]="{'background': componentSettings.simpleSliderBanner.subtitleBackground}"></div>
                </label>
                <input type="email"
                       class="form-control"
                       id="Background"
                       [(ngModel)]="componentSettings.simpleSliderBanner.subtitleBackground"
                       (change)="saveComponentSettings()">
              </div>
            </div>

            <div class="col-xs-4">
              <div class="form-group">
                <label for="subtitle-color">Subtitle Color
                  <div class="color-block"
                       [ngStyle]="{'background': componentSettings.simpleSliderBanner.subtitleColor}"></div>
                </label>
                <input class="form-control"
                       id="subtitle-color"
                       [(ngModel)]="componentSettings.simpleSliderBanner.subtitleColor"
                       (change)="saveComponentSettings()"
                       placeholder="#fff">
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label>Full Height</label>
                <md-slide-toggle id="setHeightToScreen"
                                 (change)="saveSetHeightToScreen($event)"
                                 [(ngModel)]="componentSettings.simpleSliderBanner.setHeightToScreen"> Set Height to
                  Screen</md-slide-toggle>
              </div>
            </div>
            <div class="col-xs-4">
              <div class="form-group">
                <label for="subtractFromFullHeight">Subtract from Full Height (number only)
                </label>
                <input type="number"
                       class="form-control"
                       id="subtractFromFullHeight"
                       [(ngModel)]="componentSettings.simpleSliderBanner.subtractFromFullHeight"
                       (change)="saveComponentSettings()">
              </div>
            </div>
          </ng-container>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="sliderFilter">Slider Filter (overlay)
                <div class="color-block"
                     [ngStyle]="{'background': componentSettings.simpleSliderBanner.sliderFilter}"></div>
              </label>
              <input type="email"
                     class="form-control"
                     id="sliderFilter"
                     [(ngModel)]="componentSettings.simpleSliderBanner.sliderFilter"
                     (change)="saveComponentSettings()"
                     placeholder="rgba(0, 0, 0, 0.33)">
            </div>
          </div>
        </div>

      </div>
      <app-component-structure-settings-only class="col-sm-6"
                                             [name]="'Hero Tab Box Settings'"
                                             [dataName]="'tabBoxData'"
                                             [clientData]="clientData"
                                             *ngIf="pageSettings?.home?.headerType !== 'big-title' && pageSettings?.home?.headerType !== 'insights'">
      </app-component-structure-settings-only>
      <app-component-structure-settings-only class="col-sm-6"
                                             [name]="'Big Title Hero Settings'"
                                             [dataName]="'bigTitleData'"
                                             [clientData]="clientData"
                                             *ngIf="pageSettings?.home?.headerType == 'big-title'">
      </app-component-structure-settings-only>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>LOCATION Home Page</h1>
        <hr>
      </div>
      <div class="col-sm-6">
        <h5>Hero</h5>
        <p>Header Type</p>
        <p-dropdown [options]="locationHomeHeaderType"
                    (onChange)="savePageSettings()"
                    [(ngModel)]="pageSettings?.locationHome.headerType"></p-dropdown>
        <div *ngIf="pageSettings?.locationHome.headerType == 'simple-video' || pageSettings?.locationHome.headerType == 'video' || pageSettings?.locationHome.headerType == 'big-title'"
             class="row">
          <div *ngIf="pageSettings?.locationHome.headerType == 'simple-video'"
               class="col-xs-12">
            <p-dropdown [options]="simpleHeroTabBoxOptions"
                        (onChange)="saveComponentSettings()"
                        [(ngModel)]="componentSettings.simpleHeroTabBox"
                        placeholder="Tab Box Version"></p-dropdown>
          </div>
          <div class="col-md-3 padding-top">
            <label for="videoHeaderUrl">Video Header URL</label>
          </div>
          <div class="col-md-9 padding-top">
            <input (change)="saveComponentSettings()"
                   class="full-width"
                   pInputText
                   id="videoHeaderUrl"
                   [(ngModel)]="componentSettings.videoHeaderUrl" />
          </div>
        </div>
        <br>
        <br>
        <div *ngIf="pageSettings?.locationHome.headerType == 'slider' || pageSettings?.locationHome.headerType == 'simple' || pageSettings?.locationHome.headerType == 'insights'"
             class="row">
          <div *ngIf="pageSettings?.locationHome.headerType == 'simple'"
               class="col-xs-12">
            <p-dropdown [options]="simpleHeroTabBoxOptions"
                        (onChange)="saveComponentSettings()"
                        [(ngModel)]="componentSettings.simpleHeroTabBox"
                        placeholder="Tab Box Version"></p-dropdown>
          </div>
          <div class="col-xs-12 padding-top">
            <md-slide-toggle id="showSliderArrows"
                             (change)="saveMdToggle($event, 'showSliderArrows')"
                             [(ngModel)]="componentSettings.showSliderArrows"> Show Arrows</md-slide-toggle>

          </div>
          <div class="col-xs-12">
            <md-slide-toggle id="sliderAutoPlay"
                             (change)="saveMdToggle($event, 'sliderAutoPlay')"
                             [(ngModel)]="componentSettings.sliderAutoPlay"> Autoplay Slider</md-slide-toggle>

          </div>
          <div class="col-xs-12">
            <md-slide-toggle id="sliderLocationImages"
                             (change)="saveMdToggle($event, 'sliderLocationImages')"
                             [(ngModel)]="componentSettings.sliderLocationImages"> Use different images for each
              location instead</md-slide-toggle>

          </div>

        </div>
        <!-- <div class="col-xs-12 my-5"
             *ngIf="pageSettings?.locationHome.headerType == 'slider' || pageSettings?.locationHome.headerType == 'simple' || pageSettings?.locationHome.headerType == 'insights'">

          <label>Slider Header URLs (location-specific in location settings)</label>
          <app-slideshow (onSave)="saveComponentSettings()"
                         [slides]="componentSettings.sliderUrls"
                         [showSliderArrows]="componentSettings.showSliderArrows"
                         [sliderAutoPlay]="componentSettings.sliderAutoPlay"></app-slideshow>
        </div> -->

        <div class="row mt-5">
          <div class="col-xs-12">
            <label for="subtractFromFullHeightLocation">Subtract from Full Height (number only)
            </label>
            <input type="number"
                   class="form-control"
                   id="subtractFromFullHeightLocation"
                   [(ngModel)]="pageSettings?.locationHome.subtractFromFullHeight"
                   (blur)="savePageSettings()"
                   (change)="savePageSettings()">
          </div>
        </div>
      </div>

      <app-component-structure-settings-only class="col-sm-6"
                                             [name]="'Hero Tab Box Settings'"
                                             [dataName]="'tabBoxData'"
                                             [clientData]="clientData"
                                             *ngIf="pageSettings?.home?.headerType == 'insights' && (pageSettings?.locationHome.headerType == 'simple' || pageSettings?.locationHome.headerType == 'simple-video') ">
      </app-component-structure-settings-only>
    </div>

    <component-structure class="col-sm-6"
                         [name]="'Location Homepage View Units Settings'"
                         [model]="'locationHomeViewAllUnitsComponent'"
                         [dataName]="'locationHomeViewAllUnitsData'"
                         [options]="locationHomeViewAllUnitsComponent"
                         [clientData]="clientData"></component-structure>

    <div class="row">
      <component-structure class="col-sm-6"
                           [name]="'Button Component CTA'"
                           [model]="'homePageButtonComponent'"
                           [dataName]="'homePageButtonComponentData'"
                           [clientData]="clientData"
                           [options]="homePageButtonComponent"></component-structure>

      <component-structure class="col-sm-6"
                           [name]="'Features Component'"
                           [model]="'homePageFeaturesComponent'"
                           [dataName]="'homePageFeaturesComponentData'"
                           [clientData]="clientData"
                           [options]="homePageFeaturesComponent"></component-structure>
    </div>
    <div class="row">
      <component-structure class="col-sm-6"
                           [name]="'Row of three icons Component'"
                           [model]="'homePageMainIconsComponent'"
                           [dataName]="'homePageMainIconsComponentData'"
                           [clientData]="clientData"
                           [options]="homePageMainIconsComponent"></component-structure>

      <component-structure class="col-sm-6"
                           [name]="'Find Us Component'"
                           [model]="'homePageFindUsComponent'"
                           [dataName]="'homePageFindUsComponentData'"
                           [clientData]="clientData"
                           [options]="homePageFindUsComponent"></component-structure>
    </div>
    <!--     <div class="row">
      <component-structure class="col-sm-6"
                           [name]="'Features Component Location'"
                           [model]="'homePageFeaturesComponentLocation'"
                           [clientData]="clientData"
                           [options]="homePageFeaturesComponentLocation"></component-structure>
    </div> -->
    <br>
    <h1>Hero Banners</h1>
    <div class="col-xs-12">
      <button (click)="copyAboutHeroStyles()"
              type="button"
              class="btn btn-secondary"
              color="accent"
              style="margin:15px;">Copy About Background to All</button>
    </div>
    <br>
    <div class="row margin-top">
      <div class="col-md-12">
        <h1>About Us</h1>
        <hr>
      </div>

      <component-structure class="col-sm-6"
                           [name]="'Hero'"
                           [model]="'aboutUsHero'"
                           [dataName]="'aboutUsHeroData'"
                           [clientData]="clientData"
                           [options]="aboutUsHero"></component-structure>

      <component-structure class="col-sm-6"
                           [name]="'Main Section'"
                           [model]="'aboutUsMainSection'"
                           [dataName]="'aboutUsMainSectionData'"
                           [clientData]="clientData"
                           [options]="aboutUsMainSection"></component-structure>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h1>Size Guide</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Hero'"
                           [model]="'sizeGuideHero'"
                           [dataName]="'sizeGuideHeroData'"
                           [clientData]="clientData"
                           [options]="sizeGuideHero"></component-structure>

      <component-structure class="col-sm-6"
                           [name]="'Main Section'"
                           [model]="'sizeGuideMainSection'"
                           [dataName]="'sizeGuideMainSectionData'"
                           [clientData]="clientData"
                           [options]="sizeGuideMainSection"></component-structure>
      <app-component-structure-settings-only [name]="'Rent/Reserve Buttons'"
                                             [dataName]="'sizeGuideRentReserveButtonData'"
                                             [clientData]="clientData"></app-component-structure-settings-only>
    </div>
    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Custom Pages</h1>
        <hr>
      </div>

      <component-structure class="col-sm-6"
                           [name]="'Hero'"
                           [model]="'customPageHero'"
                           [dataName]="'customPageHeroData'"
                           [clientData]="clientData"
                           [options]="customPageHero"></component-structure>
    </div>
    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Portable Quote Bar</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Portable Quote Bar'"
                           [model]="'portableQuoteBarComponent'"
                           [dataName]="'portableQuoteBarData'"
                           [clientData]="clientData"
                           [options]="portableQuoteBarComponent"></component-structure>
    </div>

    <!--     <div class="row margin-top">
      <div class="col-md-12">
        <h1>Separator Bar</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Main Separator Bar'"
                           [model]="'separatorBarComponent'"
                           [dataName]="'separatorBarData'"
                           [clientData]="clientData"
                           [options]="separatorBarComponent"></component-structure>
      <component-structure class="col-sm-6"
                           [name]="'Location Separator Bar'"
                           [model]="'locationSeparatorBarComponent'"
                           [dataName]="'locationSeparatorBarData'"
                           [clientData]="clientData"
                           [options]="locationSeparatorBarComponent"></component-structure>
    </div>
 -->
    <!--     <div class="row margin-top">
      <div class="col-md-12">
        <h1>HTML Row</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'HTML Row'"
                           [model]="'htmlRowComponent'"
                           [dataName]="'htmlRowData'"
                           [clientData]="clientData"
                           [options]="htmlRowComponent"></component-structure>
    </div> -->

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Location Banner</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Location Banner'"
                           [model]="'locationBannerComponent'"
                           [dataName]="'locationBannerData'"
                           [clientData]="clientData"
                           [options]="locationBannerComponent"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Facility Info Banner</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Facility Info Banner'"
                           [model]="'facilityInfoBannerComponent'"
                           [dataName]="'facilityInfoBannerData'"
                           [clientData]="clientData"
                           [options]="facilityInfoBannerComponent"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-6">
        <h1>Slideshow Row</h1>
        <hr>
        <component-structure [name]="'Slideshow Row'"
                             [model]="'slideshowRowComponent'"
                             [dataName]="'slideshowRowData'"
                             [clientData]="clientData"
                             [options]="slideshowRowComponent"></component-structure>
      </div>
      <div class="col-md-6">
        <h1>HowTo Row</h1>
        <hr>
        <component-structure [name]="'HowTo Row'"
                             [model]="'howToRowComponent'"
                             [dataName]="'howToRowData'"
                             [clientData]="clientData"
                             [options]="howToRowComponent"></component-structure>
      </div>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Locations Near You Banner</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Locations Near You Banner'"
                           [model]="'locationsNearYouBannerComponent'"
                           [dataName]="'locationsNearYouBannerData'"
                           [clientData]="clientData"
                           [options]="locationsNearYouBannerComponent"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Uhaul Dealer Banner</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Uhaul Dealer Banner'"
                           [model]="'uhaulDealerBannerComponent'"
                           [dataName]="'uhaulDealerBannerData'"
                           [clientData]="clientData"
                           [options]="uhaulDealerBannerComponent"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Contact</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Contact Page Header'"
                           [model]="'contactHeader'"
                           [dataName]="'contactHeaderData'"
                           [clientData]="clientData"
                           [options]="contactHeader"></component-structure>
      <component-structure class="col-sm-6"
                           [name]="'Contact Us Form'"
                           [model]="'contactForm'"
                           [dataName]="'contactFormData'"
                           [clientData]="clientData"
                           [options]="contactForm"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>View All Reviews</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'View All Reviews Header'"
                           [model]="'viewAllReviewsHeader'"
                           [dataName]="'viewAllReviewsHeaderData'"
                           [clientData]="clientData"
                           [options]="viewAllReviewsHeader"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Storage Tips</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Storage Tips Header'"
                           [model]="'storageTipsHeader'"
                           [dataName]="'storageTipsHeaderData'"
                           [clientData]="clientData"
                           [options]="storageTipsHeader"></component-structure>

      <component-structure class="col-sm-6"
                           [name]="'Storage Tips Body'"
                           [model]="'storageTipsBody'"
                           [dataName]="'storageTipsBodyData'"
                           [clientData]="clientData"
                           [options]="storageTipsBody"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>FAQs</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'FAQs Header'"
                           [model]="'faqsHeader'"
                           [dataName]="'faqsHeaderData'"
                           [clientData]="clientData"
                           [options]="faqsHeader"></component-structure>
      <component-structure class="col-sm-6"
                           [name]="'Main Section'"
                           [model]="'faqsMainSection'"
                           [dataName]="'faqsMainSectionData'"
                           [clientData]="clientData"
                           [options]="faqsMainSection"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Storage Calculator</h1>
        <p>Note: Strorage Calculator Body doesn't change anything yet as there are no options yet</p>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Storage Calculator Header'"
                           [model]="'storageCalculatorHeader'"
                           [dataName]="'storageCalculatorHeaderData'"
                           [clientData]="clientData"
                           [options]="storageCalculatorHeader"></component-structure>

      <!-- <component-structure class="col-sm-6"
                           [name]="'Storage Calculator Body'"
                           [model]="'storageCalculatorBody'"
                           [dataName]="'storageCalculatorBodyData'"
                           [clientData]="clientData"
                           [options]="storageCalculatorBody"></component-structure> -->
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>General Info</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'General Info Header'"
                           [model]="'generalInfoHeader'"
                           [dataName]="'generalInfoHeaderData'"
                           [clientData]="clientData"
                           [options]="generalInfoHeader"></component-structure>
      <component-structure class="col-sm-6"
                           [name]="'Main Section'"
                           [model]="'generalInfoMainSection'"
                           [dataName]="'generalInfoMainSectionData'"
                           [clientData]="clientData"
                           [options]="generalInfoMainSection"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Switch Location Page</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Main Section'"
                           [model]="'switchLocationComponent'"
                           [dataName]="'switchLocationComponentData'"
                           [clientData]="clientData"
                           [options]="switchLocationComponent"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Our Rates</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'View All Units Component'"
                           [model]="'viewAllUnitsComponent'"
                           [dataName]="'viewAllUnitsComponentData'"
                           [clientData]="clientData"
                           [options]="viewAllUnitsComponent"></component-structure>
      <component-structure class="col-sm-6"
                           *ngIf="clientData?.viewAllUnitsComponent == 'modern'"
                           [name]="'Header Type'"
                           [model]="'viewAllUnitsComponentHeaderType'"
                           [dataName]="'viewAllUnitsComponentHeaderTypeData'"
                           [clientData]="clientData"
                           [options]="viewAllUnitsComponentHeaderType"></component-structure>
      <component-structure class="col-sm-6"
                           *ngIf="clientData?.viewAllUnitsComponent == 'version3'"
                           [name]="'Header Type (V3 only)'"
                           [model]="'viewAllUnitsComponentHeaderType'"
                           [dataName]="'viewAllUnitsComponentHeaderTypeData'"
                           [clientData]="clientData"
                           [options]="viewAllUnitsComponentHeaderType"></component-structure>
    </div>
    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Coming Soon</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Coming Soon Component'"
                           [model]="'comingSoonComponent'"
                           [dataName]="'comingSoonComponentData'"
                           [clientData]="clientData"
                           [options]="comingSoonComponent"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Footer</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Main Section'"
                           [model]="'footer'"
                           [dataName]="'footerData'"
                           [clientData]="clientData"
                           [options]="footer"></component-structure>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Associations</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Main Section'"
                           [model]="'associations'"
                           [dataName]="'associationsData'"
                           [clientData]="clientData"
                           [options]="associations"></component-structure>
    </div>
    <div class="row"
         *ngIf="clientData.associations == 'original'">
      <div *ngFor="let link of clientData.associationLogos; let index = index">
        <input pInputText
               style="display:inline-block;margin-top:15px;width:20%"
               placeholder="url"
               [(ngModel)]="clientData.associationLogos[index].url" />
        <input pInputText
               style="display:inline-block;margin-top:15px;width:20%"
               placeholder="icon url"
               [(ngModel)]="clientData.associationLogos[index].iconUrl" />
        <input pInputText
               style="display:inline-block;margin-top:15px;width:20%"
               placeholder="Icon ALT Text"
               [(ngModel)]="clientData.associationLogos[index].altText" />
        <input pInputText
               style="display:inline-block;margin-top:15px;width:20%"
               placeholder="Icon Title Text"
               [(ngModel)]="clientData.associationLogos[index].titleText" />
        <button type="button"
                class="btn btn-primary"
                color="primary"
                style="margin-top:15px;margin-left:5%;width:10%"
                (click)="removeAssociationLink(index)">Remove</button>
      </div>

      <button type="button"
              class="btn btn-secondary"
              color="accent"
              style="margin-top:15px;"
              (click)="clientData.associationLogos.push({url: null, iconUrl: null})">Add Association Logo</button>
      <button type="button"
              class="btn btn-primary"
              color="primary"
              style="margin-top:15px;"
              (click)="updateClient()">Save Association Logos</button>
    </div>
    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Portal Login Page</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Main Component'"
                           [model]="'portalLoginComponent'"
                           [dataName]="'portalLoginData'"
                           [clientData]="clientData"
                           [options]="portalLoginComponent"></component-structure>

      <!--       <app-component-structure-settings-only [name]="'Portal Nav Bar'"
                                             [dataName]="'portalNavbarData'"
                                             [clientData]="clientData"></app-component-structure-settings-only> -->
    </div>
    <!--     <div class="row margin-top">
      <div class="col-md-12">
        <h1>Location Slideout</h1>
        <hr>
        <component-structure class="col-sm-6"
                             [name]="'Location Slideout'"
                             [model]="'locationSlideout'"
                             [dataName]="'locationSlideoutData'"
                             [clientData]="clientData"
                             [options]="locationSlideout"></component-structure>
      </div>
    </div> -->

    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Google Maps</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Google Map'"
                           [model]="'googleMapComponent'"
                           [dataName]="'googleMapData'"
                           [clientData]="clientData"
                           [options]="googleMapComponent"></component-structure>
      <!--       <component-structure class="col-sm-6"
                           [name]="'Google Map Location on Homepage'"
                           [model]="'googleMapComponentLocation'"
                           [clientData]="clientData"
                           [options]="googleMapComponentLocationOptions"></component-structure> -->
    </div>
    <div class="row margin-top">
      <div class="col-md-12">
        <h1>Store Locator</h1>
        <hr>
      </div>
      <component-structure class="col-sm-6"
                           [name]="'Store Locator Header'"
                           [model]="'storeLocatorHeader'"
                           [dataName]="'storeLocatorHeaderData'"
                           [clientData]="clientData"
                           [options]="storeLocatorHeader"></component-structure>
      <component-structure class="col-sm-6"
                           [name]="'Store Locator'"
                           [model]="'storeLocatorComponent'"
                           [dataName]="'storeLocatorData'"
                           [clientData]="clientData"
                           [options]="storeLocatorComponent"></component-structure>
    </div>
  </md-card>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/component-structure-settings/component-structure-settings.component.html